export type ApiClientSourceTrackingTransformationTypes =
  | 'GapFilled'
  | 'GapFilledMedian'
  | 'GapFilledMode'
  | 'Calculated'
  | 'Conversion'
  | 'Harmonisation'
  | 'DataVerified'
  | 'ProjectDefault'
  | 'Categorised'

export const transformationMessages: Record<
  ApiClientSourceTrackingTransformationTypes,
  string
> = {
  GapFilled: 'Value estimated from project data',
  GapFilledMedian: 'Value estimated from project data using averages (median)',
  GapFilledMode: 'Value estimated from project data using averages (mode)',
  Calculated: 'Calculated from ticket data',
  Conversion: 'Converted from ticket data',
  Harmonisation: 'Derived from ticket and project data',
  DataVerified: 'Data verified from external sources',
  ProjectDefault: 'Value set to project default',
  Categorised: 'Context aware AI categorisation'
}

const customTransformationMessages = {
  Location: 'Standardised for mileage accuracy',
  FacilityPermitId: 'Data updated using match from external sources'
}

export const getCustomTransformationMessages = (
  fieldName: string,
  transformationType: string
) => {
  switch (fieldName) {
    case 'deliveryAddressKnown':
    case 'dispatchAddressKnown':
    case 'originSiteAddressKnown':
    case 'facilitySiteAddress':
      return transformationType === 'GapFilledMode'
        ? transformationMessages.GapFilled
        : transformationType === 'Harmonisation'
          ? customTransformationMessages.Location
          : null
    case 'facilityPermitId':
      return transformationType === 'Harmonisation'
        ? customTransformationMessages.FacilityPermitId
        : null
    case 'distanceMiles':
      return transformationType === 'Calculated'
        ? 'Journey calculated from addresses'
        : null
    case 'ladenEmissionsKgCO2e':
    case 'unladenEmissionsKgCO2e':
      return transformationType === 'Calculated'
        ? 'Calculated using factors from BEIS'
        : null
    case 'embodiedCarbonKgCO2e':
      return transformationType === 'Calculated'
        ? 'Calculated using factors from ICE v3'
        : null
    default:
      return null
  }
}
